import { http, httpWithoutAuth } from 'src/utils/http.util'

export const UserService = {
  validateEmailInitPassword: async (form: any): Promise<any> => {
    return httpWithoutAuth.post('users/register/validate-email-init-password', form).then((res) => res.data)
  },
  validateEmail: async (form: any): Promise<any> => {
    return http
      .post('users/register/validate-email', { email: form.email, password: form.password, pin: form.pin })
      .then((res) => res.data)
  },
  getIsEditableUser: async (projectId: number, userId: number): Promise<boolean> => {
    return http.get(`/projects/${projectId}/users/is-editable-user/${userId}`).then((res) => res.data)
  },
  updateMe: (data: any) => {
    return http.put(`/users/me`, data)
  },
  generateNewPin: async (email: string) => {
    return http.post('users/generate-pin', { email }).then((res) => res.data)
  },
  markPlanningTutorialSeen: () => {
    return http.put('users/me/mark-planning-tutorial-seen')
  },
  getPlanningTutorialSeenAt: async (): Promise<{ shouldLaunchPlanningTutorial: boolean }> => {
    return http.get('users/me/planning-tutorial-seen-at').then((res) => res.data)
  },
}
